import {Button} from 'antd';
import {ReactElement, useEffect, useState} from 'react';
import {z} from 'zod';

import {Locale} from '../../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {useMessage} from '../../../../../../../provider/message/message-hook';
import {getFromLocalStorage} from '../../../../../../../util/local-storage';
import {useReviewStateHook} from '../../../../reviews-state/reviews-state-provider';

import bantikSrc from './common/bantik.png';
import heartSrc from './common/heart.png';
import {GlowOverlay} from './grow-overlay/grow-overlay';
import * as styles from './internal-agency-generate-button.scss';

export function InternalAgencyGenerateButton(): ReactElement {
    const {requestAIGenerate, reviews, setReviewAnswer, isBulkGenerate} = useReviewStateHook();
    const {message} = useMessage();
    const [visible, setVisible] = useState(false);
    const {getLocalizedString} = useLocale();
    const isShowHeartAnimation = getFromLocalStorage('is-show-heart-animation', z.boolean(), true);
    const ableToBulkGenerationReviews = reviews?.results.filter(
        (review) => review.ableToReply && review?.children.length === 0
    );

    function triggerAnimation() {
        setVisible(true);
    }

    useEffect(() => {
        if (!isBulkGenerate) {
            setVisible(false);
        }
    }, [isBulkGenerate]);

    function clickBulkGeneration() {
        if (ableToBulkGenerationReviews && ableToBulkGenerationReviews.length === 0) {
            message.info(getLocalizedString('REVIEW__INTERNAL_GENERATION_BUTTON__EMPTY_NOTIFICATION'));
        } else {
            triggerAnimation();
            ableToBulkGenerationReviews?.forEach((review) => {
                setReviewAnswer(review.id, '');
                requestAIGenerate(review.id);
            });
        }
    }

    return (
        <>
            <Button
                className={styles.InternalAgencyGenerateButton}
                disabled={isBulkGenerate}
                loading={isBulkGenerate}
                onClick={clickBulkGeneration}
            >
                <>
                    <img alt="" src={heartSrc} style={{display: 'none'}} />
                    <Locale stringKey="REVIEW__INTERNAL_GENERATION_BUTTON__TITLE" />
                    <img alt="" className={styles.InternalAgencyGenerateButton_image} src={bantikSrc} />
                </>
            </Button>
            {visible && isShowHeartAnimation && <GlowOverlay duration={2000} onFinish={() => setVisible(false)} />}
        </>
    );
}
